var $class="se2--header-se--login-banner",$name="HeaderSE/loginBanner",$path="app/components/HeaderSE/partials/loginBanner/config.js",$this={$class,$name,$path,};export const popupWidth = 350;
export const signInButtonSelector = '.sign-in-button';
export const signInMenuSelector = '.sign-in-menu';
export const expandedClassName = 'is-expanded';
export const menuLinkSelector = '.sign-in-menu a';
export const loginMenuPrimaryButtonSelector = '.login-menu-primary-button';
export const lastMenuLinkSelector = '.login-menu-tertiary-link';
